const MODULE = "FORMS_";

export const CHANGE_VALUE = `${MODULE}CHANGE_VALUE`;
export type CHANGE_VALUE = typeof CHANGE_VALUE;

export const REMOVE_FORM = `${MODULE}REMOVE_FORM`;
export type REMOVE_FORM = typeof REMOVE_FORM;